import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { decryptStorageValue, encryptStorageValue, purgeLegacyEntries, toStorageKey } from './storage-crypto';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  /**
   * Emits the new value whenever setItem('role', ...) is called, so components that cache the
   * current user's role at init (e.g. SettingsComponent.isteamAdmin) can react to a role change
   * made by another routed component (e.g. a self-service admin transfer) without requiring a
   * hard page reload (TRMS-2862). Starts at null; subscribers should ignore the initial value.
   */
  roleChanged$ = new BehaviorSubject<string | null>(null);

  constructor() {
    purgeLegacyEntries(localStorage);
  }

  setItem(key: string, value: any) {
    localStorage.setItem(toStorageKey(key), encryptStorageValue(value));
    if (key === 'role') {
      this.roleChanged$.next(value);
    }
  }

  getItem(key: string): any {
    return decryptStorageValue(localStorage.getItem(toStorageKey(key)));
  }

  /**
   * Method to use clear a key from local storage
   * @param key
   */
  clearItem(key: string) {
    localStorage.removeItem(toStorageKey(key));
  };

}
